import { makeObservable, observable } from 'mobx';
import { SemanticSearchReference } from './objects/SemanticSearchReference';
import { ApiaApi, makeApiaUrl } from '@apia/api';
import { FiltersStore } from '@apia/components';

/**
 * @class SearchController:
 *             - mobx Controller for the semantic search logic
 *             - search for a term and get the results. This controller must be used
 *               to maintain the state of the search string and of the results given a search string
 */
class SearchController {
  static instance = new SearchController();

  state: {
    queryString: string;
    results: SemanticSearchReference[];
    isLoading: boolean;
    disabled: boolean;
  } = { queryString: '', results: [], isLoading: false, disabled: false };

  protected constructor() {
    makeObservable(this, { state: observable });
  }

  public async search(selectedId: string) {
    const filters = await FiltersStore.getFiltersById(
      Number.parseInt(selectedId),
    );
    FiltersStore.setFilters(filters, 'U');
    SearchController.instance.state.isLoading = true;
    const response = await ApiaApi.post<{ results: SemanticSearchReference[] }>(
      makeApiaUrl({
        action: 'search',
        semSearchId: selectedId,
      }),
      {
        postData: {
          q: SearchController.instance.state.queryString,
          filters: JSON.stringify(FiltersStore.getFiltersAsFilterValue('U')),
        },
        postDataTreatement: 'stringify',
        stringifyOptions: { arrayFormat: 'repeat' },
      },
    );
    if (response?.data?.results) {
      this.setReferences(response.data.results);
    }
    this.state.isLoading = false;
  }

  protected setReferences(results: SemanticSearchReference[]) {
    if (typeof results === 'string' && results) {
      results = JSON.parse(results as any as string);
    }
    SearchController.instance.state.results = results.map((x) =>
      x instanceof SemanticSearchReference ? x : new SemanticSearchReference(x),
    );
    SearchController.instance.state.disabled = false;
  }
}

export default SearchController;
